// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import SectionHeader from 'components/text/SectionHeader';
import EmailTemplatesTable from './EmailTemplatesTable';
import EmailTemplateModal from './EmailTemplateModal';

class EmailTemplatesArea extends React.PureComponent {
  render() {
    return (
      <div>
        <div style={{ width: 550, maxWidth: '100%' }}>
          <div style={{ maxWidth: '100%' }}>
            <div style={{ position: 'relative' }}>
              <SectionHeader>Email Templates</SectionHeader>
              <div>Setup re-usable templates to use when you email contracts to clients.</div>
              <EmailTemplateModal />
              <EmailTemplatesTable />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EmailTemplatesArea;



// WEBPACK FOOTER //
// ./src/routes/app-studio/EmailTemplatesArea/index.js